module.exports = __webpack_public_path__ + "assets/img/face_check_describe.7bc1eb72.png";